import React, { useState } from "react";

import "./styles.scss";
import CustomImage from "../../shared/custom-image/custom-image";
import CustomRow from "../../shared/costum-row/costum-row";
import { Col, Typography } from "antd";
import CustomButton from "../../shared/custom-button/custom-button";
import { BREAKPOINTS, BUTTON_VARIANTS } from "../../constants/styles";
import { ArrowRightOutlined } from "@ant-design/icons";
import useBreakpoints from "../../hooks/use-breakpoints";
import { ARROW_LIGHT, ARROW_OPENER } from "../../constants/svgs";

const { Text } = Typography;

type BlogCardProps = {
  title?: string;
  date?: string;
  category?: string;
  author?: string;
  description?: string;
  imageSrc?: string;
  onClick?: () => void;
};

const BlogCard = ({
  title = "Building Resilient Webhook Handlers in AWS: Implementing DLQs for Stripe Events",
  date = "02.14.2025",
  category = "TECH",
  author = "Arnit Gashi",
  description = "Processing webhook events reliably at scale presents significant challenges for modern distributed systems. As businesses grow their payment processing operations...",
  imageSrc = "https://s3-alpha-sig.figma.com/img/d20e/9da9/5f48708e6ed36d7d92a3feac90e640af?Expires=1744588800&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=IcCEr61JFDOHQZbmSuMD-7z3RO-8kKLmOmwftq1Z1~WVdF63cL1W2FCg-9cri6fglhbI3RrkpPx~ZjMxv0pJ9jJQKXxqJ17PnBE~UKzoe0ZjxKcxDt-XHDo9aKXeIDndwN1IrrlFLsaEE2L52U827JgVNt2LWGYRBTZpK~c80743Ab-XbTufVCC4HuDvuAiHtqDOExYbeSPU7Og6VpS8tdyzFVUDv87yDfSKA21E8E82O~f9Dr1c63Jbgafz8ZeZ3lFqDg~0U9FdnhC9hH9SDgrL5lGhNJ6p3vpyijb26Dq1-pusvNMjSXaB8yXVXpI0mDj9m7QX2aOz89WRyorRfA__",
  onClick = () => {},
}: BlogCardProps) => {
  const currentBreakpoint = useBreakpoints();
  const [isHovered, setIsHovered] = useState(false);
  const isMobile = currentBreakpoint === BREAKPOINTS.MOBILE.type;

  return (
    <div
      className="BlogCard"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
    >
      <CustomImage className="BlogCard-image" src={imageSrc} />

      <CustomRow
        className="BlogCard-content"
        justify="space-between"
        isMarginNone
      >
        <Col xxl={10} xl={10} lg={10} md={9} sm={24}>
          <CustomRow gutter={[0, 40]}>
            <Col span={24}>
              <CustomRow justify="space-between">
                <Col span={8}>
                  <Text className="BlogCard-category">{category}</Text>
                </Col>
                {isMobile ? (
                  <>
                    <Col span={8}>
                      <Text className="BlogCard-date">{date}</Text>
                    </Col>
                    <Col>
                      <Text className="BlogCard-author">{author}</Text>
                    </Col>
                  </>
                ) : null}
              </CustomRow>
            </Col>

            <Col span={24}>
              <Text className="BlogCard-title">{title}</Text>
            </Col>
          </CustomRow>
        </Col>

        {!isMobile ? (
          <Col xxl={10} xl={10} lg={10} md={8} sm={24}>
            <CustomRow gutter={[0, 40]}>
              <Col span={24}>
                <CustomRow gutter={[0, 12]}>
                  <Col span={12}>
                    <Text className="BlogCard-date">{date}</Text>
                  </Col>
                  <Col span={12}>
                    <Text className="BlogCard-author">{author}</Text>
                  </Col>
                </CustomRow>
              </Col>

              <Col span={24}>
                <Text className="BlogCard-description">{description}</Text>
              </Col>
            </CustomRow>
          </Col>
        ) : null}

        <Col className="BlogCard-button-container">
          <CustomRow gutter={[0, 40]} justify="end">
            <Col span={24}>
              <CustomButton btnVariant={BUTTON_VARIANTS.TEXT} onClick={onClick}>
                Read More
              </CustomButton>
            </Col>
            {!isMobile ? (
              <Col> {isHovered ? ARROW_OPENER : ARROW_LIGHT}</Col>
            ) : null}
          </CustomRow>
        </Col>
      </CustomRow>
    </div>
  );
};

export default BlogCard;
